import { render, staticRenderFns } from "./MainMap.vue?vue&type=template&id=b91482d6&scoped=true&"
import script from "./MainMap.vue?vue&type=script&lang=js&"
export * from "./MainMap.vue?vue&type=script&lang=js&"
import style0 from "./MainMap.vue?vue&type=style&index=0&id=b91482d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91482d6",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/main_map.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fcommons%2FMainMap.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports